function t(){return"ontouchstart"in window||navigator.maxTouchPoints>0}export{t as default};
//# sourceMappingURL=isTouchDevice.js.map
